module.exports = __webpack_public_path__ + "img/Porto Apartment - 68 of 85.267d6f5a.jpeg";